export default __webpack_public_path__ + "static/media/gallery_02.65b31d9b.jpg";